// Asset-type grouping conventions — controls WHERE an asset appears in capture
// UI per PRD §7.4.2:
//   - PER_SPACE:    individual room capture screens (the majority of assets).
//   - PER_BUILDING: the "Building Common" pseudo-space only.
//   - PER_SITE:     a site-level capture screen.
//
// Values are authoritative in `groupingConventionEnum` (schema.ts). The
// `satisfies` clause makes a typo in any right-hand value fail to compile.

import { groupingConventionEnum } from '../db/schema'

export const GROUPING_CONVENTION = {
  PER_SPACE: '1 asset / space',
  PER_BUILDING: '1 asset / building',
  PER_SITE: '1 asset / site',
} as const satisfies Record<
  string,
  '1 asset / space' | '1 asset / building' | '1 asset / site'
>

export type GroupingConvention =
  '1 asset / space' | '1 asset / building' | '1 asset / site'

export const GROUPING_CONVENTION_VALUES = groupingConventionEnum.enumValues
